import { http } from '../utils/http'

const getAzureList = (params) => {
    const url = '/config/azure/page'
    return http.post(url, params)
};

const lockAction = (params) => {
    const url = '/config/azure/updateStatus'
    return http.post(url, params)
};

const saveAzure = (params) => {
    const url = '/config/azure/save'
    return http.post(url, params)
};

const getInfoAction = (id) => {
    const url = `/config/azure/getInfo/${id}`
    return http.post(url)
};

export default {
    getAzureList,
    lockAction,
    saveAzure,
    getInfoAction
}
